import { render, staticRenderFns } from "./PerformerEventsFollowShow.vue?vue&type=template&id=7a79d103&scoped=true&"
import script from "./PerformerEventsFollowShow.vue?vue&type=script&lang=js&"
export * from "./PerformerEventsFollowShow.vue?vue&type=script&lang=js&"
import style0 from "./PerformerEventsFollowShow.vue?vue&type=style&index=0&id=7a79d103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a79d103",
  null
  
)

export default component.exports